import { createSelector } from 'reselect'

export const selectUser = ({ users }) => users.user
export const selectUsers = ({ users }) => users.users
export const selectOtherUser = createSelector([selectUsers, selectUser], (users, user) =>
    users?.find((currentUser) => currentUser.id !== user.id)
)
